import React, { useEffect, useState } from 'react';
import AddOrder from './AddOrder';
import OrdersContainer from './OrdersContainer';
import OrdersSearch from './OrdersSearch';

const CO = 5;

const OrdersOperations = (
  { employees, 
    vehicles, 
    updateemployeesAndvehicles, 
    currentOrders, 
    setCurrentOrders, 
    currentRunningOrders, 
    setCurrentRunningOrders,
    clientInfo,
    updateClientInfo,
    handleCurrentRunningOrders
  }) => {
  const [orderToUpdate, setOrderToUpdate] = useState('');
  const [searchToggle, setSearchToggle] = useState(false);
  const [warnningState, setWarnningState] = useState(false);

    useEffect(() => {
      const testWarnning = currentOrders.some((x) => x.state === 'warning')
       
      if (testWarnning && !warnningState) {
        setWarnningState(true);
      }
      if (!testWarnning && warnningState) {
        setWarnningState(false);
      }
       
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentOrders])

  const handleCurrentOrders = (order, action) => {
    let newCurrentOrders = [...currentOrders];

    switch (action) {
      case 'add' :
        newCurrentOrders.push(order);
        break;
      case 'update': 
        newCurrentOrders = newCurrentOrders.map((o) => {
          if (o.id === order.id) {
            return order
          }
          return o
        });
        break;
      case 'remove':
        newCurrentOrders = newCurrentOrders.filter((o) => o.id !== order.id);
        handleCurrentRunningOrders(order.id, 'remove');
        handleCurrentemployees(order.employer, {type: 'REMOVE_ORDER', orderID: order.id})
        break;
      case 'updateEmployer': 
        newCurrentOrders = newCurrentOrders.map((o) => {
          if (o.id === order.id) {
            o.employer = order.employerID
            o.counter = 0;
            if (order.employerID) {
              let dt2 = new Date()

              handleCurrentRunningOrders(o.id, 'add')
              o.state = 'running'
              o.runningDate = dt2
            }else {
              handleCurrentRunningOrders(o.id, 'remove')
              o.state = 'pending'
            }
          }
          return o
        });
        break;
      case 'updateCounter': 
        newCurrentOrders = newCurrentOrders.map((o) => {
          if (o.id === order.id) {
            o.counter++;
            if (o.counter >= CO) {
              o.state = 'warning';
            }
          }
          return o
        });
        break;
      case 'finish': 
      newCurrentOrders = newCurrentOrders.map((o) => {
        if (o.id === order.id) {
          if (o.state !== 'fulfilled') {
            o.state = 'fulfilled'
            handleCurrentRunningOrders(o.id, 'remove');
            handleCurrentemployees(o.employer, {type: 'REMOVE_ORDER', orderID: o.id})
            handleCurrentemployees(o.employer, {type: 'ADD_FINISHED_ORDERS', orderID: o.id, price: o.price})
          }else if (o.counter >= CO) {
            o.state = 'warning';
            handleCurrentRunningOrders(o.id, 'add') 
            handleCurrentemployees(o.employer, {type: 'RE_ADD', orderID: o.id})
            handleCurrentemployees(o.employer, {type: 'REMOVE_FINISHED_ORDERS', orderID: o.id, price: o.price})
          }else {
            o.state = 'running';
            handleCurrentRunningOrders(o.id, 'add')
            handleCurrentemployees(o.employer, {type: 'RE_ADD', orderID: o.id})
            handleCurrentemployees(o.employer, {type: 'REMOVE_FINISHED_ORDERS', orderID: o.id, price: o.price})

      }
        }
        return o
      });
        break;
      default:
    }

    setCurrentOrders(newCurrentOrders);
  }
  
  const handleCurrentemployees = (employerID, action) => {
    let newCurrentemployees = [...employees];
    let newCurrentvehicles = [...vehicles];

    switch (action.type) {
      case 'ADD_ORDER': 
        newCurrentemployees = newCurrentemployees.map((e) => {
          if (e.id === employerID) {
            e.orders.push(action.orderID)
            return e
          }
          if (e.orders.includes(action.orderID)) {
            e.orders = e.orders.filter((o) => o !== action.orderID)
            return e;
          }
          return e
        });
        handleCurrentOrders({id: action.orderID, employerID}, 'updateEmployer')
        break;
      case 'RE_ADD': 
        newCurrentemployees = newCurrentemployees.map((e) => {
          if (e.id === employerID) {
            e.orders.push(action.orderID)
            e.finishedOrders.push({id: action.orderID, price: 5})
            return e
          }
          return e
        });
        break;
      case 'REMOVE_ORDER':
        newCurrentemployees = newCurrentemployees.map((e) => {
          if (e.id === employerID) {
            e.orders = e.orders.filter((o) => o !== action.orderID)
            return e
          }
          return e
          });
        break;
      case 'ADD_FINISHED_ORDERS': 
        newCurrentemployees = newCurrentemployees.map((e) => {
          if (e.id === employerID) {
            e.finishedOrders.push({id: action.orderID, price: action.price})
            return e
          }
          return e
        });
        newCurrentvehicles = newCurrentvehicles.map((m) => {
          if (m.id === employerID) {
            m.finishedOrders.push({id: action.orderID, price: action.price})
            return m
          }
          return m
        });
        break;
      case 'REMOVE_FINISHED_ORDERS':
        newCurrentemployees = newCurrentemployees.map((e) => {
          e.finishedOrders = e.finishedOrders.filter((o) => (o.id !== action.orderID))
          return e
          });
        newCurrentvehicles = newCurrentvehicles.map((m) => {
          m.finishedOrders = m.finishedOrders.filter((o) => (o.id !== action.orderID))
          return m
          });
        break;
      default:
    }
    updateemployeesAndvehicles(newCurrentemployees, newCurrentvehicles);
  }

  const updateOrder = (order) => {
    setOrderToUpdate(order);
  }

  const handleSearchToggle = () => {
    setSearchToggle(!searchToggle)
  }

  return (
    <main className='home-main'>
      <header>
        <div style={{
          background: `${warnningState ? 'red': 'lightgray'}`,
          width: '15px',
          height: '15px',
          borderRadius: '50%',
          marginLeft: '20px',
          border: '2px solid lightgray'}}>
        </div>

        <section className='currentemployees'>
          {employees.map((employer) => (
            employer.state === 'on' && <p 
              key={employer.id} 
              title={`started at ___ ( ${employer.time[0]} : ${employer.time[1]} ) \nhis motorcycle ___ ${employer.vehicle.name}`}
              style={{color: `${employer.orders.length ? 'darkgray' : 'black'}`}}
            >« {employer.name} »</p>
          ))}
        </section>
        <div 
          className='orders-search'
          onClick={() => handleSearchToggle()}
        >☌</div>

        {searchToggle&& 
          <OrdersSearch 
            currentOrders={currentOrders}
            updateOrder={updateOrder}
            handleCurrentOrders={handleCurrentOrders}
            employees={employees}
            handleCurrentemployees={handleCurrentemployees}
            currentRunningOrders={currentRunningOrders}
            handleSearch={handleSearchToggle}
          />
        }
      </header>
      <OrdersContainer 
        currentOrders={currentOrders}
        updateOrder={updateOrder}
        handleCurrentOrders={handleCurrentOrders}
        employees={employees}
        handleCurrentemployees={handleCurrentemployees}
        currentRunningOrders={currentRunningOrders}
      />
      
      <AddOrder 
        handleCurrentOrders={handleCurrentOrders}
        orderToUpdate={orderToUpdate}
        handleUpdateOrder={updateOrder}
        clientInfo={clientInfo}
        updateClientInfo={updateClientInfo}
      />
    </main>
  )
}

export default OrdersOperations;